// Import model
import { GridFormRowLayout } from '../models/GridFormRowLayout';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { GridFormFieldLayout } from '../models/GridFormFieldLayout';

// Import dependency serializers (for complex types)
import { GridFormFieldLayoutSerializer } from './GridFormFieldLayoutSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for GridFormRowLayout - handles JSON serialization and deserialization with type validation
 */
export class GridFormRowLayoutSerializer {
  /**
   * Deserializes a JSON string into a GridFormRowLayout instance
   */
  static deserialize(json: string): GridFormRowLayout {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a GridFormRowLayout instance
   */
  static fromObject(obj: any): GridFormRowLayout {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to GridFormRowLayout');
    }


    const instance: GridFormRowLayout = {
      fields: obj['Fields'] ? (obj['Fields'] as any[]).map((item: any) =>
        GridFormFieldLayoutSerializer.fromObject(item)
      ) : [],
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of GridFormRowLayout instances
   */
  static deserializeArray(json: string): GridFormRowLayout[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a GridFormRowLayout instance to a JSON string
   */
  static serialize(instance: GridFormRowLayout): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a GridFormRowLayout instance to a plain object
   */
  static toObject(instance: GridFormRowLayout): any {
    return {
      'Fields': instance.fields?.map((item: any) =>
        GridFormFieldLayoutSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of GridFormRowLayout instances to a JSON string
   */
  static serializeArray(instances: GridFormRowLayout[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
